module.exports = __webpack_public_path__ + "assets/media/google-play-footer.764f4562.svg";